import { useQuery } from "react-query";
import { onError } from "./onError";
import { axios } from "../../lib/axios";
import moment from "moment";
import { useSelector } from "react-redux";

export function usePatientEncounterHistoryQuery({ startDate, endDate, patientId, onSuccess, practitionerId, ...props }) {
    // Convert dates to local timezone ISO format
    const orgId = useSelector((state) => state?.auth?.user?.organizations?.[0]?.id);
    const startDateISO = moment(startDate).startOf('day').toISOString();
    const endDateISO = moment(endDate).endOf('day').toISOString();
    const fetch = () => {
        if(practitionerId) return axios.get(`encounter/search?patientID=${patientId}&practitionerId=${practitionerId}&DateStart=${startDateISO}&DateEnd=${endDateISO}&status=finished&type=closed&orgId=${orgId}&getAll=false`)
        else return axios.get(`encounter/search?patientID=${patientId}&DateStart=${startDateISO}&DateEnd=${endDateISO}&status=finished&type=closed&orgId=${orgId}&getAll=false`)
    }

    const query = useQuery(
        ["patient-medication", startDate, endDate, patientId],
        () => fetch(),
        {
            select: (data) => {
                return data?.data?.filter(item => item.status === 'finished');
            },
            onSuccess,
            onError,
            ...props
        }
    );

    return { ...query }
}